module.exports = __webpack_public_path__ + "fonts/5a67b0ed-239e-4f3e-adeb-8b1e517a5bd3.f87546b0.woff";